import Vue from "vue";
import vuetify from "./plugins/vuetify";
// import "vuetify/dist/vuetify.min.css";
import vueCustomElement from "vue-custom-element";

import ControlPanel from "./components/ControlPanel.vue";

Vue.use(vueCustomElement);

Vue.customElement("control-panel", ControlPanel, {
  beforeCreateVueInstance(rootElement) {
    console.log("rootElement", rootElement);
    rootElement.vuetify = vuetify;
    return rootElement;
  },
});

// if (import.meta.env.DEV) {
//   new Vue({
//     vuetify,
//     render: (h) =>
//       h(ControlPanel, {
//         attrs: {
//           call_id: "57c37d8a45899f81edf372ae1cc6db26",
//           standalone: true,
//         },
//         on: {
//           stateChange: (state) => console.log("stateChange", state),
//         },
//       }),
//   }).$mount("#app");
// }
